// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add styles for the container */
.file-upload-container {
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
}

/* Style the file upload button */
.file-upload input[type="file"] {
  display: none;
}

.file-upload button {
  background-color: #005460;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

/* Style the drop area */
.drop-area {
  border: 1px dashed;
  padding: 20px;
  text-align: center;
  border-radius: 5px;
  transition: border 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* Add effect on drop */
.drop-area.selected {
  border-color: #42b983;
  /* Change border color on file drop */
  background-color: transparent;
  /* Change background color on file drop */
}


.go_back_recipients {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.mdi-arrow-left {
  font-size: 22px;
  cursor: pointer;
}

.recipients_loader {
  height: 100px;
}


.arrowAndBtnWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.file_upload_note {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin-right: auto;
}

.errorRows {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  overflow: auto;
}

.errorRowsLimitIncrease {
  height: 250px;
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.hide_progress_bar {
  display: none;
}

.errorText {
  color: var(--bs-red) !important;
}

.btnAndLoderWrapper {
  position: relative;
  display: flex;
  /* height: 50px; */
}

.btnAndLoderWrapper button {
  cursor: pointer;
}

.fileUploadLoader {
  position: absolute;
  top: -30%;
  left: 50%;
}

.sample_file_link{
  text-align: right;
  color: #005460;
  cursor: pointer;
  border-bottom: 2px solid #005460;
}

.sample_file_link:hover{
  color: #00a4bb;
  border-bottom: 2px solid #00a4bb;
}

/* Upload Recipients Detailed Error Styles */
.upload-error-details {
  background-color: #ffffff;
  border: 1px solid #f5c2c7;
  border-radius: 6px;
  padding: 12px 14px;
  cursor: default;
  width: 100%;
}

.upload-error-details .table-responsive {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.upload-error-details table {
  margin-bottom: 0;
  width: 100%;
}

.upload-error-details table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  padding: 6px 10px;
}

.upload-error-details table td {
  vertical-align: middle;
  padding: 6px 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/FileUpload/FileUpload.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;EAC7B,yCAAyC;AAC3C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":["/* Add styles for the container */\r\n.file-upload-container {\r\n  background-color: white;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Style the file upload button */\r\n.file-upload input[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\n.file-upload button {\r\n  background-color: #005460;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Style the drop area */\r\n.drop-area {\r\n  border: 1px dashed;\r\n  padding: 20px;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  transition: border 0.3s;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Add effect on drop */\r\n.drop-area.selected {\r\n  border-color: #42b983;\r\n  /* Change border color on file drop */\r\n  background-color: transparent;\r\n  /* Change background color on file drop */\r\n}\r\n\r\n\r\n.go_back_recipients {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.mdi-arrow-left {\r\n  font-size: 22px;\r\n  cursor: pointer;\r\n}\r\n\r\n.recipients_loader {\r\n  height: 100px;\r\n}\r\n\r\n\r\n.arrowAndBtnWrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.file_upload_note {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: start;\r\n  align-items: start;\r\n  margin-right: auto;\r\n}\r\n\r\n.errorRows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 70%;\r\n  overflow: auto;\r\n}\r\n\r\n.errorRowsLimitIncrease {\r\n  height: 250px;\r\n  width: 70%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: auto;\r\n}\r\n\r\n.hide_progress_bar {\r\n  display: none;\r\n}\r\n\r\n.errorText {\r\n  color: var(--bs-red) !important;\r\n}\r\n\r\n.btnAndLoderWrapper {\r\n  position: relative;\r\n  display: flex;\r\n  /* height: 50px; */\r\n}\r\n\r\n.btnAndLoderWrapper button {\r\n  cursor: pointer;\r\n}\r\n\r\n.fileUploadLoader {\r\n  position: absolute;\r\n  top: -30%;\r\n  left: 50%;\r\n}\r\n\r\n.sample_file_link{\r\n  text-align: right;\r\n  color: #005460;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid #005460;\r\n}\r\n\r\n.sample_file_link:hover{\r\n  color: #00a4bb;\r\n  border-bottom: 2px solid #00a4bb;\r\n}\r\n\r\n/* Upload Recipients Detailed Error Styles */\r\n.upload-error-details {\r\n  background-color: #ffffff;\r\n  border: 1px solid #f5c2c7;\r\n  border-radius: 6px;\r\n  padding: 12px 14px;\r\n  cursor: default;\r\n  width: 100%;\r\n}\r\n\r\n.upload-error-details .table-responsive {\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n}\r\n\r\n.upload-error-details table {\r\n  margin-bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n.upload-error-details table thead th {\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  border-bottom: 2px solid #dee2e6;\r\n  padding: 6px 10px;\r\n}\r\n\r\n.upload-error-details table td {\r\n  vertical-align: middle;\r\n  padding: 6px 10px;\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
